import { useTranslation } from 'react-i18next';
import { Info, LucideExternalLink } from 'lucide-react';
import { cn } from '../../utils/styleUtil';
import { isInternalUrl } from '../../utils/urlUtil';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { Button } from '../ui/button';

export function SupplierInfo({
  article,
  className
}: Readonly<{
  className?: string;
  article: {
    supplierGroupMinOrderValue?: number;
    supplierGroupName: string;
    supplierGroupTermsDocumentName: string;
    supplierGroupTermsDocumentUrl?: string;
  };
}>) {
  const { t } = useTranslation();

  const handleClick = () => {
    const features = isInternalUrl(article.supplierGroupTermsDocumentUrl!) ? '' : 'noopener,noreferrer';
    window.open(article.supplierGroupTermsDocumentUrl, '_blank', features);
  };

  let warningIcon;

  if (article.supplierGroupMinOrderValue) {
    const text = `${t('Mindestbestellwert')} CHF ${article.supplierGroupMinOrderValue.toFixed(2)}`;
    warningIcon = (
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" className={cn('hover:bg-primary-light flex items-center justify-center')}>
            <Info />
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p className={'font-bold'}>{text}</p>
        </TooltipContent>
      </Tooltip>
    );
  } else {
    warningIcon = <Info />;
  }

  let info;

  if (article.supplierGroupName && article.supplierGroupTermsDocumentUrl) {
    info = (
      <Button
        variant={'link'}
        onClick={handleClick}
        className={'flex flex-wrap whitespace-normal break-words p-0 mt-2 h-auto'}
      >
        {t('Hier finden Sie die Preis- und Lieferkonditionen von {{0}}.', {
          0: article.supplierGroupName
        })}
        <LucideExternalLink size={24} className={'ml-2'} />
      </Button>
    );
  } else {
    info = <span>{t('Es gelten spezielle Preis- und Lieferkonditionen!')}</span>;
  }

  return (
    <div
      key={'SupplierInfo'}
      className={cn('flex desktop:flex-row flex-col border-t h-[50px] items-center', className)}
    >
      <div className={'mr-4'}>{warningIcon}</div>
      <div className={'mb-2 block desktop:hidden'}>{info}</div>
      <div>
        <span className={'hidden desktop:block'}>{info}</span>
        {t('KEIN RÜCKGABERECHT')}
      </div>
    </div>
  );
}
